{
  "block_page_editor": {
    "add_comment": "Add comment",
    "untitled_placeholder": "Untitled"
  },
  "block_page_list_menu_options": {
    "page_options_aria_label": "page options",
    "long_menu_aria_controls": "long-menu",
    "delete_page_aria_label": "delete page"
  },
  "block_page_list": {
    "add_page_aria_label": "add page",
    "add_page": "Add Page",
    "page_names_aria_label": "page names",
    "untitled_page": "Untitled Page"
  },
  "block_page_ui": {
    "loading_page_aria_label": "loading page",
    "error_prefix": "Error: "
  },
  "task_with_section_block": {
    "add_task": "Add Task",
    "task_name_empty_error": "Task name cannot be empty",
    "add_task_error": "An unexpected error occurred while adding the task.",
    "section_placeholder": "Type task section or select existing section",
    "create_section_error": "An unexpected error occurred while creating the section.",
    "create_new_task_aria": "create new task",
    "add_task_to_section_aria": "Add a new task to section",
    "toggle_dropdown_aria": "Toggle section dropdown",
    "section_title_aria": "section-title"
  },
  "block_note_emoji_picker": {
    "add_emoji": "Add Emoji"
  },
  "block_provider_editor": {
    "syncing": "Syncing..."
  },
  "remove_page": {
    "confirm_delete_title": "Are you sure you want to delete this page?",
    "confirm_delete_content": "Click the confirm button to delete the page."
  },
  "images_block": {
    "insert_image_url": "Insert Image URL",
    "image_url": "Image URL",
    "image_url_placeholder": "Enter image URL",
    "image_url_required": "Image URL is required.",
    "image_caption": "Image Caption",
    "image_caption_placeholder": "Enter image caption",
    "insert_image": "Insert Image"
  },
  "contact_card_block": {
    "contact_required": "Contact is required",
    "contact": "Contact",
    "add_contact_card": "Add contact card",
    "add_contact_card_placeholder": "Add contact card by name or email"
  }
}
